import React from "react";
import { Briefcase, Music2, Radio, Megaphone } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export default function Services() {
  const { t } = useLang();
  const services = [
    { icon: Briefcase, key: "management", num: "01" },
    { icon: Music2, key: "production", num: "02" },
    { icon: Radio, key: "distribution", num: "03" },
    { icon: Megaphone, key: "promo", num: "04" },
  ];

  return (
    <div data-testid="services-page">
      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 pt-16 pb-16">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">— Servizi</div>
        <h1 className="font-display text-6xl md:text-8xl uppercase leading-[0.9] text-[#0A0A0A]">
          {t("services.title", "Servizi")}
        </h1>
        <p className="mt-8 max-w-2xl text-lg text-[#0A0A0A]/70">{t("services.subtitle", "")}</p>
      </section>

      <section className="border-t-2 border-[#0A0A0A]">
        <div className="mx-auto max-w-[1400px] grid md:grid-cols-2">
          {services.map((s2, i) => (
            <div
              key={s2.key}
              className={`p-10 lg:p-14 border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-[#FAFAF7] group transition-colors duration-500 ${
                i % 2 === 0 ? "md:border-r-2" : ""
              } ${i < 2 ? "border-b-2" : ""}`}
              data-testid={`service-block-${s2.key}`}
            >
              <div className="flex items-start justify-between mb-8">
                <s2.icon size={40} strokeWidth={1.5} className="text-[#FF5A1F]" />
                <span className="text-xs font-bold uppercase tracking-widest opacity-40">{s2.num}</span>
              </div>
              <h2 className="font-display text-4xl md:text-5xl uppercase leading-none">
                {t(`services.${s2.key}.title`, "")}
              </h2>
              <p className="mt-6 text-base leading-relaxed opacity-80 max-w-lg">
                {t(`services.${s2.key}.text`, "")}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
